import { render, staticRenderFns } from "./SectionConfig.vue?vue&type=template&id=01a45972&scoped=true&"
import script from "./SectionConfig.vue?vue&type=script&lang=js&"
export * from "./SectionConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a45972",
  null
  
)

export default component.exports